
<val-boite-dialogue-generique #boiteDialogue
                              class="val-selection-complement-comptable-dialogue"
                              [titre]="'complement-comptable.selection-dialogue.titre' | transloco"
                              [validerDesactive]="true"
                              (validerClick)="Valider()"
                              (annulerClick)="Annuler()">
  <div bandeau
       class="val-selection-complement-comptable-dialogue-bandeau">
    <val-simple-libelle [libelle]="'complement-comptable.selection-dialogue.bandeau' | transloco: { numeroFacture: donnees.numeroFacture }"></val-simple-libelle>
  </div>
  <div contenu
       class="val-selection-complement-comptable-dialogue-contenu">
    <val-simple-panel>
      <div class="val-selection-complement-comptable-dialogue-contenu-grille val-flex-conteneur">
        <val-grille #grille
                    [colonnes]="colonnes"
                    champSelection="identifiant"
                    [donnees]="donnees.complementsComptable"
                    [simpleSelection]="true"
                    (selectionChange)="ExecuterActionSurChangementSelection($event)">
        </val-grille>
      </div>
    </val-simple-panel>
  </div>
</val-boite-dialogue-generique>
